import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Input,
} from "@angular/core";
import { SimplebarAngularComponent } from "simplebar-angular";
import { TranslateService } from "@ngx-translate/core";

import {
  DomSanitizer,
  SafeResourceUrl,
  SafeUrl,
} from "@angular/platform-browser";

import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import {
  IMAGE_THUMB_SIZE,
  IMAGE_UPLOAD_MAX_BYTES,
  IMAGE_UPLOAD_MAX_COUNT,
  IMAGE_UPLOAD_MAX_MB,
  IMAGE_UPLOAD_MAX_ORIGINAL_BYTES,
  UploadProgress,
  compressImage,
  isValidImageType,
  prepareUploadFile,
  probeImageDimensions,
  renderFitThumbnail,
} from "./image-upload.util";
import { shouldFitWhole } from "./cropperr/crop-math";

// Light Box
import { IEvent, Lightbox, LightboxEvent, LIGHTBOX_EVENT } from "ngx-lightbox";

import Swal from "sweetalert2";
import { Subscription } from "rxjs";

import { EventService } from "src/app/core/services/event.service";

import { CropperrComponent } from "./cropperr/cropperr.component";

import { PropertiesService } from "../../services/properties.services";
import { LoadingService } from "src/app/core/services/loading.service";
import { PermissionsService } from "src/app/core/services/permissions.service";
import { PropertyValidationRulesService } from "src/app/core/services/propertyValidationRules.service";
import JSZip from "jszip";
import {
  AiCreditRequestContext,
  AiIntegrationsService,
} from "src/app/core/services/ai-integrations.service";
import { AiWalletStateService } from "src/app/core/services/ai-wallet-state.service";
import { PropertyDataService } from "src/app/core/services/property-data.service";
import { ActivityLogsService } from "src/app/core/services/logs.service";
@Component({
  selector: "app-multimedia",
  templateUrl: "./multimedia.component.html",
  styleUrls: ["./multimedia.component.scss"],
})
export class MultimediaComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() property: any;
  @Input() propertyMultimediaData: any;

  imageChangedEvent: any = "";
  croppedImage: any = "";
  images: { id: number; src: string; thumb: string; caption?: string }[] = [];
  videos: any[] = [];

  @ViewChild(CropperrComponent, { static: true })
  cropperComponent!: CropperrComponent;

  @ViewChild("simplebarMultimedia", { static: false })
  showCropper = false;

  subscriptionCropImage!: Subscription;
  subscriptionSubmitted!: Subscription;
  private lightboxsubscription!: Subscription;
  subscriptionRules?: Subscription;

  filterredImages: any;
  filterredVideos: any;
  galleryFilter = "images";

  list: any = { images: [], videos: [] };
  listDeleteImages: any = [];
  listDeleteVideos: any = [];

  countImages = 0;
  modalAddVideo!: NgbModalRef;
  multimediaFirst: number = 1;
  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any[];
    associatedUsers?: any;
  };

  @ViewChild("simplebarMultimedia", { static: false })
  simplebarMultimedia!: SimplebarAngularComponent;
  /** Preparação das fotos novas em curso (uma de cada vez), com progresso na página. */
  uploadProgress: UploadProgress | null = null;


  draggedImageIndex: number | null = null;
  dragOverImageIndex: number | null = null;

  dragOverPosition: "before" | "after" | null = null;

  multimediaMinError: any | null = null;
  showMultimediaMinWarning = false;
  homeStagingAvailable = false;
  imageEnhancementAvailable = false;
  homeStagingGenerating = false;
  imageEnhancementGenerating = false;
  homeStagingError = "";
  imageEnhancementError = "";
  homeStagingSelectedImage: any = null;
  imageEnhancementSelectedImage: any = null;
  homeStagingResults: any[] = [];
  imageEnhancementResults: any[] = [];
  homeStagingCreditCost = 0;
  imageEnhancementCreditCost = 0;
  canRequestCreditTopUps = true;
  creditRequestContext: AiCreditRequestContext | null = null;
  homeStagingLoadingMessageIndex = 0;
  imageEnhancementLoadingMessageIndex = 0;
  private homeStagingLoadingTimer: any = null;
  private imageEnhancementLoadingTimer: any = null;
  private homeStagingRequestKey = "";
  private imageEnhancementRequestKey = "";
  homeStagingLoadingMessages = [
    "home-staging-ai.loading.analyzingImage",
    "home-staging-ai.loading.identifyingRoom",
    "home-staging-ai.loading.preparingOptions",
    "home-staging-ai.loading.refiningLighting",
    "home-staging-ai.loading.finalizing",
  ];
  imageEnhancementLoadingMessages = [
    "image-enhancement-ai.loading.analyzingImage",
    "image-enhancement-ai.loading.preparingEnhancements",
    "image-enhancement-ai.loading.correctingDetails",
    "image-enhancement-ai.loading.refiningImage",
    "image-enhancement-ai.loading.finalizing",
  ];
  homeStagingForm = {
    roomType: "auto",
    style: "modern",
    quality: "high" as "auto" | "low" | "medium" | "high",
    variants: 1,
    customInstructions: "",
  };
  imageEnhancementForm = {
    enhancements: ["auto"] as string[],
    quality: "high" as "auto" | "low" | "medium" | "high",
    customInstructions: "",
  };
  homeStagingRoomOptions = [
    { value: "auto", labelKey: "home-staging-ai.rooms.auto" },
    { value: "living_room", labelKey: "home-staging-ai.rooms.livingRoom" },
    { value: "bedroom", labelKey: "home-staging-ai.rooms.bedroom" },
    { value: "kitchen", labelKey: "home-staging-ai.rooms.kitchen" },
    { value: "dining_room", labelKey: "home-staging-ai.rooms.diningRoom" },
    { value: "office", labelKey: "home-staging-ai.rooms.office" },
    { value: "bathroom", labelKey: "home-staging-ai.rooms.bathroom" },
    { value: "terrace", labelKey: "home-staging-ai.rooms.terrace" },
    { value: "empty_room", labelKey: "home-staging-ai.rooms.emptyRoom" },
    { value: "commercial", labelKey: "home-staging-ai.rooms.commercial" },
  ];
  homeStagingStyleOptions = [
    { value: "modern", labelKey: "home-staging-ai.styles.modern" },
    { value: "scandinavian", labelKey: "home-staging-ai.styles.scandinavian" },
    { value: "luxury", labelKey: "home-staging-ai.styles.luxury" },
    { value: "minimalist", labelKey: "home-staging-ai.styles.minimalist" },
    { value: "warm", labelKey: "home-staging-ai.styles.warm" },
    { value: "industrial", labelKey: "home-staging-ai.styles.industrial" },
    { value: "classic", labelKey: "home-staging-ai.styles.classic" },
    { value: "coastal", labelKey: "home-staging-ai.styles.coastal" },
    { value: "family", labelKey: "home-staging-ai.styles.family" },
    { value: "investment", labelKey: "home-staging-ai.styles.investment" },
  ];
  homeStagingQualityOptions = [
    { value: "high", labelKey: "home-staging-ai.qualities.high" },
    { value: "medium", labelKey: "home-staging-ai.qualities.medium" },
    { value: "auto", labelKey: "home-staging-ai.qualities.auto" },
  ];
  homeStagingVariantOptions = [
    { value: 1, labelKey: "home-staging-ai.variantsOptions.one" },
    { value: 2, labelKey: "home-staging-ai.variantsOptions.two" },
    { value: 3, labelKey: "home-staging-ai.variantsOptions.three" },
    { value: 4, labelKey: "home-staging-ai.variantsOptions.four" },
  ];
  imageEnhancementOptions = [
    {
      value: "auto",
      icon: "ri-sun-line",
      labelKey: "image-enhancement-ai.enhancements.auto",
      descriptionKey: "image-enhancement-ai.enhancementsDescriptions.auto",
    },
    {
      value: "perspective",
      icon: "ri-layout-masonry-line",
      labelKey: "image-enhancement-ai.enhancements.perspective",
      descriptionKey:
        "image-enhancement-ai.enhancementsDescriptions.perspective",
    },
    {
      value: "declutter",
      icon: "ri-eraser-line",
      labelKey: "image-enhancement-ai.enhancements.declutter",
      descriptionKey: "image-enhancement-ai.enhancementsDescriptions.declutter",
    },
    {
      value: "blue_sky",
      icon: "ri-cloud-line",
      labelKey: "image-enhancement-ai.enhancements.blueSky",
      descriptionKey: "image-enhancement-ai.enhancementsDescriptions.blueSky",
    },
    {
      value: "day_to_dusk",
      icon: "ri-moon-clear-line",
      labelKey: "image-enhancement-ai.enhancements.dayToDusk",
      descriptionKey: "image-enhancement-ai.enhancementsDescriptions.dayToDusk",
    },
    {
      value: "upscale",
      icon: "ri-fullscreen-line",
      labelKey: "image-enhancement-ai.enhancements.upscale",
      descriptionKey: "image-enhancement-ai.enhancementsDescriptions.upscale",
    },
  ];

  constructor(
    private lightbox: Lightbox,
    private lightboxEvent: LightboxEvent,
    private eventService: EventService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private propertiesService: PropertiesService,
    public translate: TranslateService,
    private loadingService: LoadingService,
    public permissionsService: PermissionsService,
    private propertyValidationService: PropertyValidationRulesService,
    private aiIntegrationsService: AiIntegrationsService,
    private aiWalletState: AiWalletStateService,
    private propertyDataService: PropertyDataService,
    private activityLogsService: ActivityLogsService,
  ) { }

  /**
   * Histórico do imóvel: as imagens são servidas sem sessão, por isso o
   * servidor não sabe quem as vê — é a galeria que o diz. Só imagens já
   * gravadas (com `fileId`); uma imagem nova ainda não existe no imóvel.
   */
  private trackImageEvent(
    image: any,
    action: "PROPERTY_IMAGE_VIEWED" | "PROPERTY_IMAGE_DOWNLOAD_REQUESTED",
  ) {
    const fileId = Number(image?.fileId);
    if (!this.property?.id || !Number.isFinite(fileId) || fileId <= 0) return;
    this.activityLogsService.trackPropertyEvent(this.property.id, {
      action,
      fileId,
      context: "gallery",
    });
  }

  loadImges() {
    this.countImages = 0;
    this.filterredImages = this.list.images;
    this.images = [];
    for (const im of this.list.images) {
      const item: any = {
        id: im?.id,
        src: im?.img,
        caption: im?.caption,
        thumb: im?.img,
      };
      this.images.push(item);
      this.countImages++;
    }
  }

  loadVideos() {
    this.filterredVideos = this.list.videos;
    this.videos = [];
    for (const im of this.list.videos) {
      const item: any = {
        id: im.id,
        src: "/assets/images/placeholder.png",
      };
      this.videos.push(item);
    }
  }

  ngOnInit(): void {
    const { id, role, stores, associatedUsers } =
      this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores, associatedUsers };

    this.list = this.propertyMultimediaData.data;
    if (this.list?.first) {
      this.multimediaFirst = this.list?.first;
    }
    this.listDeleteImages = this.propertyMultimediaData.dataDeleteImages;
    this.listDeleteVideos = this.propertyMultimediaData.dataDeleteVideos;
    this.loadImges();
    this.loadVideos();
    this.syncListingImages();
    this.loadHomeStagingAvailability();
    this.loadHomeStagingCreditContext();

    this.subscriptionRules = this.propertyValidationService
      .rules$()
      .subscribe((map) => {
        if (!map?.size) return;
        this.refreshMultimediaWarnings();
      });

    if (!this.subscriptionCropImage) {
      this.subscriptionCropImage = this.eventService.subscribe(
        "crop-image",
        (data: any) => {
          // O cropper só emite coordenadas: a imagem fica igual até o
          // servidor regenerar a publicada ao guardar a ficha. O preview
          // (500 px) serve só para o card.
          if (!data) return;
          const d: any = this.list.images?.find(
            (x: { id: any }) => x?.id === data?.id,
          );
          if (!d) return;
          d.crop = data.crop ?? null;
          d.cropDirty = true;
          d.cropPreview = data.cropPreview ?? null;
          if (!d.originalThumb) d.originalThumb = d.thumb;
          if (data.cropPreview) {
            d.img = data.cropPreview;
            d.thumb = data.cropPreview;
          } else if (d.originalThumb) {
            d.img = d.originalThumb;
            d.thumb = d.originalThumb;
          }
          this.loadImges();
          this.refreshMultimediaWarnings();
        },
      );
    }
  }

  ngAfterViewInit(): void {
    this.subscriptionSubmitted = this.eventService.subscribe(
      "get-data-tab-multimedia",
      () => {
        this.refreshMultimediaWarnings();
      },
    );
  }

  /***
   * Active all category selected
   */
  activeCategory(category: string) {
    this.galleryFilter = category;
    if (this.galleryFilter === "videos") {
      this.filterredVideos = this.list.videos;
    } else if (this.galleryFilter === "images") {
      this.filterredImages = this.list.images.filter(
        (x: { category: string }) => x.category === this.galleryFilter,
      );
    }
  }

  open(index: number): void {
    this.lightboxsubscription = this.lightboxEvent.lightboxEvent$.subscribe(
      (event: any) => this.onReceivedEvent(event),
    );
    // open lightbox
    if (this.galleryFilter === "videos") {
      this.lightbox.open(this.videos, index, {});
      let v: any = this.list.videos.find(
        (x: { id: any }) => x.id === index + 1,
      );
      const templateVideo: string = `<div class="ratio" style="--vz-aspect-ratio: 67%;">
      <iframe src="${v.link.changingThisBreaksApplicationSecurity}" title="YouTube video" allowfullscreen></iframe>
  </div>`;
      const t = setInterval(() => {
        const el: any = document.getElementById("image");
        if (el) {
          const c = el.parentElement;
          el.remove();
          c.innerHTML += templateVideo;
          clearInterval(t);
        }
      });
    } else {
      this.lightbox.open(this.images, index, {});
      this.trackImageEvent(this.filterredImages?.[index], "PROPERTY_IMAGE_VIEWED");
    }
  }

  close(): void {
    // close lightbox programmatically
    this.lightbox.close();
  }

  addImage() {
    const inputFile = document.getElementById("input-file-img");
    inputFile?.click();
  }

  canEditMultimedia(): boolean {
    return (
      this.permissionsService.checkPropertyAgentPermission(
        this.property,
        "EDIT_PROPERTIES",
      ) ||
      this.permissionsService.canEditProperty(
        this.loginUser,
        this.property?.store?.id,
      ) ||
      !this.property
    );
  }

  private loadHomeStagingAvailability() {
    this.aiIntegrationsService.getServicesWithStatus().subscribe({
      next: (services) => {
        const homeStagingService = (services ?? []).find(
          (service: any) =>
            String(service?.code ?? "").toUpperCase() === "HOME_STAGING_AI" &&
            service?.activated === true,
        );
        this.homeStagingAvailable = !!homeStagingService;
        const effectiveCost = Number(homeStagingService?.effectiveCreditCost);
        this.homeStagingCreditCost = Number.isFinite(effectiveCost)
          ? effectiveCost
          : Number(homeStagingService?.defaultCreditCost ?? 0);

        const imageEnhancementService = (services ?? []).find(
          (service: any) =>
            String(service?.code ?? "").toUpperCase() ===
            "IMAGE_ENHANCEMENT_AI" && service?.activated === true,
        );
        this.imageEnhancementAvailable = !!imageEnhancementService;
        const imageEnhancementEffectiveCost = Number(
          imageEnhancementService?.effectiveCreditCost,
        );
        this.imageEnhancementCreditCost = Number.isFinite(
          imageEnhancementEffectiveCost,
        )
          ? imageEnhancementEffectiveCost
          : Number(imageEnhancementService?.defaultCreditCost ?? 0);
      },
      error: () => {
        this.homeStagingAvailable = false;
        this.homeStagingCreditCost = 0;
        this.imageEnhancementAvailable = false;
        this.imageEnhancementCreditCost = 0;
      },
    });
  }

  private loadHomeStagingCreditContext() {
    this.aiIntegrationsService.getCreditRequestContext().subscribe({
      next: (ctx) => {
        this.creditRequestContext = ctx;
        this.canRequestCreditTopUps = ctx?.canRequestCredits ?? true;
      },
      error: () => {
        this.creditRequestContext = null;
        this.canRequestCreditTopUps = true;
      },
    });
  }

  private isSameHomeStagingImage(a: any, b: any): boolean {
    if (!a || !b) return false;
    return (
      a === b ||
      (a?.id != null && b?.id != null && String(a.id) === String(b.id)) ||
      (!!this.getImageUrl(a) && this.getImageUrl(a) === this.getImageUrl(b))
    );
  }

  private resetHomeStagingDraft() {
    this.homeStagingResults = [];
    this.homeStagingError = "";
    this.homeStagingRequestKey = "";
    this.homeStagingForm = {
      roomType: "auto",
      style: "modern",
      quality: "high",
      variants: 1,
      customInstructions: "",
    };
  }

  getHomeStagingVariantCount(): number {
    const variants = Number(this.homeStagingForm.variants);
    return Number.isFinite(variants)
      ? Math.min(10, Math.max(1, Math.floor(variants)))
      : 1;
  }

  getHomeStagingTotalCreditCost(): number {
    return (
      Math.max(0, Number(this.homeStagingCreditCost || 0)) *
      this.getHomeStagingVariantCount()
    );
  }

  private resetImageEnhancementDraft() {
    this.imageEnhancementResults = [];
    this.imageEnhancementError = "";
    this.imageEnhancementRequestKey = "";
    this.imageEnhancementForm = {
      enhancements: ["auto"],
      quality: "high",
      customInstructions: "",
    };
  }

  getImageEnhancementTotalCreditCost(): number {
    return Math.max(0, Number(this.imageEnhancementCreditCost || 0));
  }

  getImageEnhancementSelectionCount(): number {
    return this.imageEnhancementForm.enhancements.length;
  }

  isImageEnhancementSelected(value: string): boolean {
    return this.imageEnhancementForm.enhancements.includes(value);
  }

  canSelectImageEnhancement(value: string): boolean {
    return (
      this.isImageEnhancementSelected(value) ||
      this.imageEnhancementForm.enhancements.length < 3
    );
  }

  toggleImageEnhancement(value: string) {
    const selected = this.imageEnhancementForm.enhancements;
    if (selected.includes(value)) {
      const next = selected.filter((item) => item !== value);
      this.imageEnhancementForm.enhancements = next.length ? next : ["auto"];
      return;
    }

    if (selected.length >= 3) {
      this.imageEnhancementError = this.translate.instant(
        "image-enhancement-ai.maxEnhancementsError",
      );
      return;
    }

    this.imageEnhancementError = "";
    this.imageEnhancementForm.enhancements = [...selected, value];
  }

  onHomeStagingSelectedImageChange(image: any) {
    if (this.isSameHomeStagingImage(this.homeStagingSelectedImage, image)) {
      this.homeStagingSelectedImage = image;
      return;
    }

    this.homeStagingSelectedImage = image;
    this.resetHomeStagingDraft();
  }

  onImageEnhancementSelectedImageChange(image: any) {
    if (
      this.isSameHomeStagingImage(this.imageEnhancementSelectedImage, image)
    ) {
      this.imageEnhancementSelectedImage = image;
      return;
    }

    this.imageEnhancementSelectedImage = image;
    this.resetImageEnhancementDraft();
  }

  openHomeStagingModal(content: any, image?: any) {
    if (!this.homeStagingAvailable || !this.canEditMultimedia()) return;

    const nextSelectedImage =
      image ??
      this.homeStagingSelectedImage ??
      (this.filterredImages ?? this.list.images ?? []).find(
        (item: any) => item?.status !== false && item?.isAvailable !== false,
      ) ??
      null;

    if (
      !this.homeStagingGenerating &&
      !this.isSameHomeStagingImage(this.homeStagingSelectedImage, nextSelectedImage)
    ) {
      this.resetHomeStagingDraft();
    }

    this.homeStagingSelectedImage = nextSelectedImage;
    this.homeStagingError = "";

    this.modalService.open(content, {
      size: "xl",
      centered: true,
      backdropClass: "custom-body",
      windowClass: "home-staging-modal",
      backdrop: "static",
    });
  }

  openImageEnhancementModal(content: any, image?: any) {
    if (!this.imageEnhancementAvailable || !this.canEditMultimedia()) return;

    const nextSelectedImage =
      image ??
      this.imageEnhancementSelectedImage ??
      (this.filterredImages ?? this.list.images ?? []).find(
        (item: any) => item?.status !== false && item?.isAvailable !== false,
      ) ??
      null;

    if (
      !this.imageEnhancementGenerating &&
      !this.isSameHomeStagingImage(
        this.imageEnhancementSelectedImage,
        nextSelectedImage,
      )
    ) {
      this.resetImageEnhancementDraft();
    }

    this.imageEnhancementSelectedImage = nextSelectedImage;
    this.imageEnhancementError = "";

    this.modalService.open(content, {
      size: "xl",
      centered: true,
      backdropClass: "custom-body",
      windowClass: "home-staging-modal",
      backdrop: "static",
    });
  }

  async dismissHomeStagingModal(modal: any) {
    if (this.homeStagingGenerating) {
      const result = await Swal.fire({
        icon: "info",
        title: this.translate.instant("home-staging-ai.closeWhileGeneratingTitle"),
        text: this.translate.instant("home-staging-ai.closeWhileGeneratingText"),
        showCancelButton: true,
        confirmButtonText: this.translate.instant("home-staging-ai.closeWhileGeneratingConfirm"),
        cancelButtonText: this.translate.instant("t-cancel"),
        confirmButtonColor: "rgb(54, 69, 116)",
        cancelButtonColor: "#878a99",
      });
      if (!result.isConfirmed) return;
    }

    modal.dismiss("Cross click");
  }

  async dismissImageEnhancementModal(modal: any) {
    if (this.imageEnhancementGenerating) {
      const result = await Swal.fire({
        icon: "info",
        title: this.translate.instant("image-enhancement-ai.closeWhileGeneratingTitle"),
        text: this.translate.instant("image-enhancement-ai.closeWhileGeneratingText"),
        showCancelButton: true,
        confirmButtonText: this.translate.instant("image-enhancement-ai.closeWhileGeneratingConfirm"),
        cancelButtonText: this.translate.instant("t-cancel"),
        confirmButtonColor: "rgb(54, 69, 116)",
        cancelButtonColor: "#878a99",
      });
      if (!result.isConfirmed) return;
    }

    modal.dismiss("Cross click");
  }

  private getImageUrl(image: any): string {
    const raw = image?.img?.changingThisBreaksApplicationSecurity ?? image?.img;
    return String(raw ?? "");
  }

  private async resolveHomeStagingSourceFile(image: any): Promise<File | Blob> {
    if (image?.originalFile instanceof File || image?.originalFile instanceof Blob) {
      return image.originalFile;
    }

    const url = this.getImageUrl(image);
    if (!url) throw new Error("Imagem sem origem válida.");

    const response = await fetch(url, { credentials: "include" });
    if (!response.ok) throw new Error("Não foi possível carregar a imagem.");
    const blob = await response.blob();
    return new File([blob], image?.name || "property-image.jpg", {
      type: blob.type || "image/jpeg",
    });
  }

  private buildHomeStagingPropertyContext(): Record<string, any> {
    return {
      propertyType:
        this.property?.details?.propertyTypeData?.description ??
        this.property?.details?.propertyType ??
        undefined,
      typology:
        this.property?.details?.typologyData?.description ??
        this.property?.details?.typology ??
        undefined,
      condition:
        this.property?.details?.conditionData?.description ??
        this.property?.details?.condition ??
        undefined,
      businessType:
        this.property?.details?.businessTypeData?.description ??
        this.property?.details?.businessType ??
        undefined,
      location:
        [
          this.property?.address?.parish?.name,
          this.property?.address?.county?.name,
          this.property?.address?.district?.name,
        ]
          .filter(Boolean)
          .join(", "),
    };
  }

  private formatCreditAmount(value: number | null): string {
    if (value === null || !Number.isFinite(value)) {
      return this.translate.instant(
        "ai-feedback.creditConfirm.balanceUnavailable",
      );
    }
    return `${Math.max(0, Math.floor(value)).toLocaleString("pt-PT")} ${this.translate.instant("ai-feedback.creditConfirm.creditsLabel")}`;
  }

  private getCurrentWalletBalance(): number | null {
    const value = this.aiWalletState.balance;
    if (typeof value !== "number" || !Number.isFinite(value)) return null;
    return Math.max(0, value);
  }

  private resolveErrorPayload(payload: any): { message: string; code: string } {
    const code = String(
      payload?.errorCode ??
      payload?.error?.errorCode ??
      payload?.code ??
      "",
    ).toUpperCase();

    const message =
      payload?.errorMessage ??
      payload?.error?.errorMessage ??
      payload?.error?.message ??
      payload?.message ??
      this.translate.instant("ai-feedback.genericErrorBody");

    return { message, code };
  }

  private isInsufficientCreditsError(payload: any): boolean {
    const { message, code } = this.resolveErrorPayload(payload);
    const normalizedMessage = String(message).toLowerCase();
    return (
      code.includes("INSUFFICIENT") ||
      code.includes("BALANCE") ||
      normalizedMessage.includes("sem créditos") ||
      normalizedMessage.includes("saldo insuficiente") ||
      normalizedMessage.includes("insufficient credit")
    );
  }

  private openGenericAiError(message: string) {
    Swal.fire({
      icon: "error",
      title: this.translate.instant("ai-feedback.genericErrorTitle"),
      text: message || this.translate.instant("ai-feedback.genericErrorBody"),
      confirmButtonText: this.translate.instant("t-close"),
      confirmButtonColor: "rgb(54, 69, 116)",
    });
  }

  private openInsufficientCreditsFlow(
    fallbackMessage?: string,
    contextKey = "ai-feedback.context.homeStaging",
  ) {
    const canRequestTopUps = this.canRequestCreditTopUps;
    Swal.fire({
      icon: "warning",
      title: this.translate.instant("ai-feedback.insufficientCreditsTitle"),
      html: `
        <p class="mb-2">${fallbackMessage || this.translate.instant("ai-feedback.insufficientCreditsBody")}</p>
        <small class="text-muted">${this.translate.instant("ai-feedback.insufficientCreditsHint")}</small>
      `,
      showCancelButton: canRequestTopUps,
      confirmButtonText: canRequestTopUps
        ? this.translate.instant("ai-feedback.requestCreditsAction")
        : this.translate.instant("t-close"),
      cancelButtonText: this.translate.instant("t-cancel"),
      confirmButtonColor: "rgb(64, 81, 137)",
      cancelButtonColor: "#878a99",
    }).then((res) => {
      if (res.isConfirmed && canRequestTopUps)
        this.promptCreditRequest(contextKey);
    });
  }

  private promptCreditRequest(contextKey = "ai-feedback.context.homeStaging") {
    if (!this.canRequestCreditTopUps) {
      this.openGenericAiError(
        this.translate.instant("ai-feedback.requestCreditsNotAllowed"),
      );
      return;
    }

    Swal.fire({
      title: this.translate.instant("ai-feedback.requestCreditsModalTitle"),
      input: "number",
      inputValue: 50,
      inputAttributes: {
        min: "1",
        step: "1",
      },
      showCancelButton: true,
      confirmButtonText: this.translate.instant(
        "ai-feedback.requestCreditsSubmit",
      ),
      cancelButtonText: this.translate.instant("t-cancel"),
      confirmButtonColor: "rgb(64, 81, 137)",
      preConfirm: (value) => {
        const credits = Number(value);
        if (!Number.isFinite(credits) || credits < 1) {
          Swal.showValidationMessage(
            this.translate.instant("ai-feedback.requestCreditsValidation"),
          );
          return null;
        }
        return credits;
      },
    }).then((res) => {
      if (!res.isConfirmed || !res.value) return;
      const creditsRequested = Number(res.value);
      const reason = this.translate.instant("ai-feedback.requestCreditsReason", {
        context: this.translate.instant(contextKey),
      });

      this.aiIntegrationsService
        .createCreditRequest({
          creditsRequested,
          reason,
        })
        .subscribe({
          next: () => {
            Swal.fire({
              icon: "success",
              title: this.translate.instant(
                "ai-feedback.requestCreditsSuccessTitle",
              ),
              text: this.translate.instant(
                "ai-feedback.requestCreditsSuccessBody",
              ),
              confirmButtonText: this.translate.instant("t-close"),
              confirmButtonColor: "rgb(54, 69, 116)",
            });
          },
          error: (err: any) => {
            const { message } = this.resolveErrorPayload(err);
            this.openGenericAiError(message);
          },
        });
    });
  }

  private async confirmHomeStagingCreditConsumption(): Promise<boolean> {
    const baseCost = Math.max(0, Number(this.homeStagingCreditCost || 0));
    const variants = this.getHomeStagingVariantCount();
    const cost = this.getHomeStagingTotalCreditCost();
    const currentBalance = this.getCurrentWalletBalance();
    const projectedBalance =
      currentBalance === null ? null : currentBalance - cost;
    const insufficient = projectedBalance !== null && projectedBalance < 0;
    const canRequestTopUps = this.canRequestCreditTopUps;

    const result = await Swal.fire({
      title: this.translate.instant("ai-feedback.creditConfirm.title"),
      text: this.translate.instant("ai-feedback.creditConfirm.subtitle"),
      html: `
        <div class="ai-credit-cost-modal">
          <div class="ai-credit-cost-section">
            <div class="ai-credit-cost-section__title">${this.translate.instant("ai-feedback.creditConfirm.selectedServiceLabel")}</div>
            <div class="ai-credit-service-card">
              <div class="ai-credit-service-card__icon"><i class="ri-image-edit-line"></i></div>
              <div class="ai-credit-service-card__content">
                <strong>${this.translate.instant("ai-feedback.creditConfirm.services.homeStaging.name")}</strong>
                <small>${this.translate.instant("ai-feedback.creditConfirm.services.homeStaging.description")}</small>
                <small>${this.translate.instant("home-staging-ai.costFormula", {
        variants,
        cost: baseCost,
        total: cost,
      })}</small>
              </div>
              <div class="ai-credit-service-card__cost">
                <strong>${cost}</strong>
                <span>${this.translate.instant("ai-feedback.creditConfirm.creditsLabel")}</span>
              </div>
            </div>
          </div>
          <div class="ai-credit-cost-section">
            <div class="ai-credit-cost-section__title">${this.translate.instant("ai-feedback.creditConfirm.summaryLabel")}</div>
            <div class="ai-credit-confirm__ledger">
              <div class="ai-credit-confirm__row">
                <span>${this.translate.instant("ai-feedback.creditConfirm.currentBalance")}</span>
                <strong>${this.formatCreditAmount(currentBalance)}</strong>
              </div>
              <div class="ai-credit-confirm__row">
                <span>${this.translate.instant("ai-feedback.creditConfirm.cost")}</span>
                <strong class="is-cost">-${cost.toLocaleString("pt-PT")} ${this.translate.instant("ai-feedback.creditConfirm.creditsLabel")}</strong>
              </div>
              <div class="ai-credit-confirm__row ai-credit-confirm__row--result">
                <span>${this.translate.instant("ai-feedback.creditConfirm.afterBalance")}</span>
                <strong class="${insufficient ? "is-danger" : "is-ok"}">${this.formatCreditAmount(projectedBalance)}</strong>
              </div>
            </div>
            <small class="ai-credit-confirm__hint-info">${this.translate.instant("ai-feedback.creditConfirm.afterHint")}</small>
            ${insufficient ? `<small class="ai-credit-confirm__hint">${this.translate.instant("ai-feedback.creditConfirm.insufficientHint")}</small>` : ""}
          </div>
        </div>
      `,
      showCancelButton: !insufficient || canRequestTopUps,
      showCloseButton: true,
      confirmButtonText: insufficient
        ? canRequestTopUps
          ? this.translate.instant("ai-feedback.requestCreditsAction")
          : this.translate.instant("t-close")
        : this.translate.instant("ai-feedback.creditConfirm.confirmWithCost", {
          cost,
        }),
      cancelButtonText: this.translate.instant("t-cancel"),
      confirmButtonColor: insufficient ? "#f06548" : "rgb(64, 81, 137)",
      cancelButtonColor: "#878a99",
      customClass: {
        popup: "ai-credit-confirm-popup",
        confirmButton: "ai-credit-confirm-btn ai-credit-confirm-btn--confirm",
        cancelButton: "ai-credit-confirm-btn ai-credit-confirm-btn--cancel",
      },
      buttonsStyling: false,
      preConfirm: () =>
        new Promise((resolve) => {
          const popup = Swal.getPopup();
          popup?.classList.add("ai-credit-confirm-popup--committing");
          setTimeout(() => resolve(true), 450);
        }),
    });

    if (!result.isConfirmed) return false;
    if (insufficient) {
      if (canRequestTopUps) {
        this.promptCreditRequest();
      } else {
        this.openGenericAiError(
          this.translate.instant("ai-feedback.requestCreditsNotAllowed"),
        );
      }
      return false;
    }
    return true;
  }

  private async confirmImageEnhancementCreditConsumption(): Promise<boolean> {
    const cost = this.getImageEnhancementTotalCreditCost();
    const currentBalance = this.getCurrentWalletBalance();
    const projectedBalance =
      currentBalance === null ? null : currentBalance - cost;
    const insufficient = projectedBalance !== null && projectedBalance < 0;
    const canRequestTopUps = this.canRequestCreditTopUps;

    const result = await Swal.fire({
      title: this.translate.instant("ai-feedback.creditConfirm.title"),
      text: this.translate.instant("ai-feedback.creditConfirm.subtitle"),
      html: `
        <div class="ai-credit-cost-modal">
          <div class="ai-credit-cost-section">
            <div class="ai-credit-cost-section__title">${this.translate.instant("ai-feedback.creditConfirm.selectedServiceLabel")}</div>
            <div class="ai-credit-service-card">
              <div class="ai-credit-service-card__icon"><i class="ri-image-edit-line"></i></div>
              <div class="ai-credit-service-card__content">
                <strong>${this.translate.instant("ai-feedback.creditConfirm.services.imageEnhancement.name")}</strong>
                <small>${this.translate.instant("ai-feedback.creditConfirm.services.imageEnhancement.description")}</small>
                <small>${this.translate.instant("image-enhancement-ai.costHint", {
        count: this.getImageEnhancementSelectionCount(),
      })}</small>
              </div>
              <div class="ai-credit-service-card__cost">
                <strong>${cost}</strong>
                <span>${this.translate.instant("ai-feedback.creditConfirm.creditsLabel")}</span>
              </div>
            </div>
          </div>
          <div class="ai-credit-cost-section">
            <div class="ai-credit-cost-section__title">${this.translate.instant("ai-feedback.creditConfirm.summaryLabel")}</div>
            <div class="ai-credit-confirm__ledger">
              <div class="ai-credit-confirm__row">
                <span>${this.translate.instant("ai-feedback.creditConfirm.currentBalance")}</span>
                <strong>${this.formatCreditAmount(currentBalance)}</strong>
              </div>
              <div class="ai-credit-confirm__row">
                <span>${this.translate.instant("ai-feedback.creditConfirm.cost")}</span>
                <strong class="is-cost">-${cost.toLocaleString("pt-PT")} ${this.translate.instant("ai-feedback.creditConfirm.creditsLabel")}</strong>
              </div>
              <div class="ai-credit-confirm__row ai-credit-confirm__row--result">
                <span>${this.translate.instant("ai-feedback.creditConfirm.afterBalance")}</span>
                <strong class="${insufficient ? "is-danger" : "is-ok"}">${this.formatCreditAmount(projectedBalance)}</strong>
              </div>
            </div>
            <small class="ai-credit-confirm__hint-info">${this.translate.instant("ai-feedback.creditConfirm.afterHint")}</small>
            ${insufficient ? `<small class="ai-credit-confirm__hint">${this.translate.instant("ai-feedback.creditConfirm.insufficientHint")}</small>` : ""}
          </div>
        </div>
      `,
      showCancelButton: !insufficient || canRequestTopUps,
      showCloseButton: true,
      confirmButtonText: insufficient
        ? canRequestTopUps
          ? this.translate.instant("ai-feedback.requestCreditsAction")
          : this.translate.instant("t-close")
        : this.translate.instant("ai-feedback.creditConfirm.confirmWithCost", {
          cost,
        }),
      cancelButtonText: this.translate.instant("t-cancel"),
      confirmButtonColor: insufficient ? "#f06548" : "rgb(64, 81, 137)",
      cancelButtonColor: "#878a99",
      customClass: {
        popup: "ai-credit-confirm-popup",
        confirmButton: "ai-credit-confirm-btn ai-credit-confirm-btn--confirm",
        cancelButton: "ai-credit-confirm-btn ai-credit-confirm-btn--cancel",
      },
      buttonsStyling: false,
      preConfirm: () =>
        new Promise((resolve) => {
          const popup = Swal.getPopup();
          popup?.classList.add("ai-credit-confirm-popup--committing");
          setTimeout(() => resolve(true), 450);
        }),
    });

    if (!result.isConfirmed) return false;
    if (insufficient) {
      if (canRequestTopUps) {
        this.promptCreditRequest("ai-feedback.context.imageEnhancement");
      } else {
        this.openGenericAiError(
          this.translate.instant("ai-feedback.requestCreditsNotAllowed"),
        );
      }
      return false;
    }
    return true;
  }

  private handleHomeStagingError(payload: any) {
    const { message } = this.resolveErrorPayload(payload);
    if (this.isInsufficientCreditsError(payload)) {
      this.openInsufficientCreditsFlow(message);
      return;
    }
    this.openGenericAiError(message);
  }

  private handleImageEnhancementError(payload: any) {
    const { message } = this.resolveErrorPayload(payload);
    if (this.isInsufficientCreditsError(payload)) {
      this.openInsufficientCreditsFlow(
        message,
        "ai-feedback.context.imageEnhancement",
      );
      return;
    }
    this.openGenericAiError(message);
  }

  private notifyHomeStagingConsumption(result: any) {
    if (!result?.ok) return;
    this.aiWalletState.applyConsumption(
      result.remainingBalance,
      result.creditsConsumed ?? this.getHomeStagingTotalCreditCost() ?? 1,
    );
  }

  private notifyImageEnhancementConsumption(result: any) {
    if (!result?.ok) return;
    this.aiWalletState.applyConsumption(
      result.remainingBalance,
      result.creditsConsumed ?? this.getImageEnhancementTotalCreditCost() ?? 1,
    );
  }

  private isAiTimeoutError(payload: any): boolean {
    const normalizedMessage = this.normalizeAiTimeoutPayload(payload);
    const statusValues = [
      payload?.status,
      payload?.statusCode,
      payload?.error?.status,
      payload?.error?.statusCode,
      payload?.error?.code,
      payload?.error?.error?.status,
      payload?.error?.error?.statusCode,
      payload?.error?.error?.code,
    ];
    if (
      statusValues.some((value) => {
        const text = String(value ?? "");
        return Number(value) === 504 || text.includes("504");
      })
    ) {
      return true;
    }

    const requestUrl = String(
      payload?.url ?? payload?.error?.url ?? "",
    ).toLowerCase();
    const isAiUploadRequest =
      requestUrl.includes("/ai-integrations/usage/") &&
      requestUrl.includes("/upload");

    const isCorsMaskedGatewayTimeout =
      Number(payload?.status) === 0 &&
      (isAiUploadRequest ||
        normalizedMessage.includes("unknown error") ||
        normalizedMessage.includes("http failure response") ||
        normalizedMessage.includes("err_failed"));

    if (isCorsMaskedGatewayTimeout) return true;

    return (
      normalizedMessage.includes("timeout") ||
      normalizedMessage.includes("timed out") ||
      normalizedMessage.includes("tempo limite") ||
      normalizedMessage.includes("gateway timeout") ||
      normalizedMessage.includes("gateway time-out") ||
      normalizedMessage.includes("gateway timed out") ||
      normalizedMessage.includes("504 gateway") ||
      normalizedMessage.includes("504")
    );
  }

  private normalizeAiTimeoutPayload(payload: any): string {
    const values = new Set<string>();
    const add = (value: any) => {
      if (value === null || value === undefined) return;
      const text = String(value).trim();
      if (text && text !== "[object Object]") values.add(text);
    };

    const visit = (value: any, depth = 0) => {
      if (value === null || value === undefined || depth > 3) return;
      if (["string", "number", "boolean"].includes(typeof value)) {
        add(value);
        return;
      }
      if (Array.isArray(value)) {
        value.forEach((item) => visit(item, depth + 1));
        return;
      }
      if (typeof value !== "object") return;

      [
        "message",
        "errorMessage",
        "code",
        "errorCode",
        "name",
        "status",
        "statusCode",
        "statusText",
        "url",
        "type",
      ].forEach((key) => visit(value?.[key], depth + 1));

      visit(value?.error, depth + 1);
    };

    visit(payload);
    const { message, code } = this.resolveErrorPayload(payload);
    add(message);
    add(code);

    return Array.from(values).join(" ").toLowerCase();
  }

  private isAiPendingResult(payload: any): boolean {
    return String(payload?.status ?? "").toUpperCase() === "PENDING";
  }

  private applyHomeStagingResult(result: any): boolean {
    if (this.isAiPendingResult(result)) return true;

    if (!result?.ok) {
      this.homeStagingError =
        result?.errorMessage ||
        this.translate.instant("home-staging-ai.generateError");
      this.handleHomeStagingError(result);
      return false;
    }

    this.notifyHomeStagingConsumption(result);
    this.homeStagingResults = (result?.output?.["images"] ?? []).map(
      (image: any) => ({
        ...image,
        comparePosition: 50,
      }),
    );
    return true;
  }

  private recoverHomeStagingAfterTimeout(idempotencyKey: string) {
    this.aiIntegrationsService
      .waitForUsageResultByIdempotency(idempotencyKey, {
        maxAttempts: 48,
        intervalMs: 5000,
      })
      .subscribe({
        next: (result) => this.applyHomeStagingResult(result),
        error: (error) => {
          this.homeStagingError =
            error?.error?.message ||
            this.translate.instant("home-staging-ai.generateError");
          this.handleHomeStagingError(error);
        },
      })
      .add(() => {
        this.homeStagingGenerating = false;
        this.stopHomeStagingLoadingMessages();
      });
  }

  private applyImageEnhancementResult(result: any): boolean {
    if (this.isAiPendingResult(result)) return true;

    if (!result?.ok) {
      this.imageEnhancementError =
        result?.errorMessage ||
        this.translate.instant("image-enhancement-ai.generateError");
      this.handleImageEnhancementError(result);
      return false;
    }

    this.notifyImageEnhancementConsumption(result);
    this.imageEnhancementResults = (result?.output?.["images"] ?? []).map(
      (image: any) => ({
        ...image,
        comparePosition: 50,
      }),
    );
    return true;
  }

  private recoverImageEnhancementAfterTimeout(idempotencyKey: string) {
    this.aiIntegrationsService
      .waitForUsageResultByIdempotency(idempotencyKey, {
        maxAttempts: 48,
        intervalMs: 5000,
      })
      .subscribe({
        next: (result) => this.applyImageEnhancementResult(result),
        error: (error) => {
          this.imageEnhancementError =
            error?.error?.message ||
            this.translate.instant("image-enhancement-ai.generateError");
          this.handleImageEnhancementError(error);
        },
      })
      .add(() => {
        this.imageEnhancementGenerating = false;
        this.stopImageEnhancementLoadingMessages();
      });
  }

  private startHomeStagingLoadingMessages() {
    this.stopHomeStagingLoadingMessages();
    this.homeStagingLoadingMessageIndex = 0;
    this.homeStagingLoadingTimer = setInterval(() => {
      this.homeStagingLoadingMessageIndex =
        (this.homeStagingLoadingMessageIndex + 1) %
        this.homeStagingLoadingMessages.length;
    }, 3600);
  }

  private stopHomeStagingLoadingMessages() {
    if (!this.homeStagingLoadingTimer) return;
    clearInterval(this.homeStagingLoadingTimer);
    this.homeStagingLoadingTimer = null;
  }

  private startImageEnhancementLoadingMessages() {
    this.stopImageEnhancementLoadingMessages();
    this.imageEnhancementLoadingMessageIndex = 0;
    this.imageEnhancementLoadingTimer = setInterval(() => {
      this.imageEnhancementLoadingMessageIndex =
        (this.imageEnhancementLoadingMessageIndex + 1) %
        this.imageEnhancementLoadingMessages.length;
    }, 3600);
  }

  private stopImageEnhancementLoadingMessages() {
    if (!this.imageEnhancementLoadingTimer) return;
    clearInterval(this.imageEnhancementLoadingTimer);
    this.imageEnhancementLoadingTimer = null;
  }

  async generateHomeStaging() {
    if (!this.homeStagingSelectedImage) {
      this.homeStagingError = this.translate.instant(
        "home-staging-ai.selectImageError",
      );
      return;
    }

    if (!(await this.confirmHomeStagingCreditConsumption())) return;

    this.homeStagingGenerating = true;
    this.homeStagingError = "";
    this.homeStagingResults = [];
    this.startHomeStagingLoadingMessages();

    try {
      const sourceFile = await this.resolveHomeStagingSourceFile(
        this.homeStagingSelectedImage,
      );
      const idempotencyKey = `home-staging-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 9)}`;
      this.homeStagingRequestKey = idempotencyKey;
      let recoveringAfterTimeout = false;

      this.aiIntegrationsService
        .executeHomeStagingUpload({
          idempotencyKey,
          image: sourceFile,
          imageName: this.homeStagingSelectedImage?.name || "property-image.jpg",
          propertyId: this.property?.id,
          roomType: this.homeStagingForm.roomType,
          style: this.homeStagingForm.style,
          quality: this.homeStagingForm.quality,
          variants: this.homeStagingForm.variants,
          customInstructions: this.homeStagingForm.customInstructions,
          imageCaption: this.homeStagingSelectedImage?.caption,
          propertyContext: this.buildHomeStagingPropertyContext(),
        })
        .subscribe({
          next: (result) => {
            if (this.isAiPendingResult(result)) {
              recoveringAfterTimeout = true;
              this.recoverHomeStagingAfterTimeout(idempotencyKey);
              return;
            }
            if (this.isAiTimeoutError(result)) {
              recoveringAfterTimeout = true;
              this.recoverHomeStagingAfterTimeout(idempotencyKey);
              return;
            }
            this.applyHomeStagingResult(result);
          },
          error: (error) => {
            if (this.isAiTimeoutError(error)) {
              recoveringAfterTimeout = true;
              this.recoverHomeStagingAfterTimeout(idempotencyKey);
              return;
            }
            this.homeStagingError =
              error?.error?.message ||
              this.translate.instant("home-staging-ai.generateError");
            this.handleHomeStagingError(error);
          },
        })
        .add(() => {
          if (recoveringAfterTimeout) return;
          this.homeStagingGenerating = false;
          this.stopHomeStagingLoadingMessages();
        });
    } catch (error: any) {
      this.homeStagingError =
        error?.message ||
        this.translate.instant("home-staging-ai.prepareImageError");
      this.homeStagingGenerating = false;
      this.stopHomeStagingLoadingMessages();
    }
  }

  downloadHomeStagingImage(image: any) {
    const link = document.createElement("a");
    link.href = image?.dataUrl;
    link.download = image?.fileName || "home-staging-ai.jpg";
    link.click();
  }

  addHomeStagingImageToProperty(image: any) {
    if (!image?.dataUrl) return;

    const id = this.list.images.length + 1;
    const file = this.dataUrlToFile(
      image.dataUrl,
      image.fileName || `home-staging-ai-${id}.jpg`,
    );
    const url = URL.createObjectURL(file);
    const safeUrl = this.getSafeImageUrl(url);

    this.list.images.push({
      id,
      name: file.name,
      img: safeUrl,
      caption: '',
      category: "images",
      thumb: safeUrl,
      isNew: true,
      autoCrop: false,
      originalFile: file,
      status: true,
      isAvailable: true,
      hasMaster: true,
      crop: null,
      cropDirty: false,
      cropPreview: null,
      // Regulamento IA da UE (art. 50): marcada automaticamente.
      isAiGenerated: true,
      aiServiceCode: "HOME_STAGING_AI",
    });

    this.loadImges();
    this.refreshMultimediaWarnings();

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: this.translate.instant("home-staging-ai.added"),
      showConfirmButton: false,
      timer: 2200,
    });
  }

  async generateImageEnhancement() {
    if (!this.imageEnhancementSelectedImage) {
      this.imageEnhancementError = this.translate.instant(
        "image-enhancement-ai.selectImageError",
      );
      return;
    }

    if (!this.imageEnhancementForm.enhancements.length) {
      this.imageEnhancementError = this.translate.instant(
        "image-enhancement-ai.selectEnhancementError",
      );
      return;
    }

    if (this.imageEnhancementForm.enhancements.length > 3) {
      this.imageEnhancementError = this.translate.instant(
        "image-enhancement-ai.maxEnhancementsError",
      );
      return;
    }

    if (!(await this.confirmImageEnhancementCreditConsumption())) return;

    this.imageEnhancementGenerating = true;
    this.imageEnhancementError = "";
    this.imageEnhancementResults = [];
    this.startImageEnhancementLoadingMessages();

    try {
      const sourceFile = await this.resolveHomeStagingSourceFile(
        this.imageEnhancementSelectedImage,
      );
      const idempotencyKey = `image-enhancement-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 9)}`;
      this.imageEnhancementRequestKey = idempotencyKey;
      let recoveringAfterTimeout = false;

      this.aiIntegrationsService
        .executeImageEnhancementUpload({
          idempotencyKey,
          image: sourceFile,
          imageName:
            this.imageEnhancementSelectedImage?.name || "property-image.jpg",
          propertyId: this.property?.id,
          enhancements: this.imageEnhancementForm.enhancements,
          quality: this.imageEnhancementForm.quality,
          customInstructions: this.imageEnhancementForm.customInstructions,
          imageCaption: this.imageEnhancementSelectedImage?.caption,
          propertyContext: this.buildHomeStagingPropertyContext(),
        })
        .subscribe({
          next: (result) => {
            if (this.isAiPendingResult(result)) {
              recoveringAfterTimeout = true;
              this.recoverImageEnhancementAfterTimeout(idempotencyKey);
              return;
            }
            if (this.isAiTimeoutError(result)) {
              recoveringAfterTimeout = true;
              this.recoverImageEnhancementAfterTimeout(idempotencyKey);
              return;
            }
            this.applyImageEnhancementResult(result);
          },
          error: (error) => {
            if (this.isAiTimeoutError(error)) {
              recoveringAfterTimeout = true;
              this.recoverImageEnhancementAfterTimeout(idempotencyKey);
              return;
            }
            this.imageEnhancementError =
              error?.error?.message ||
              this.translate.instant("image-enhancement-ai.generateError");
            this.handleImageEnhancementError(error);
          },
        })
        .add(() => {
          if (recoveringAfterTimeout) return;
          this.imageEnhancementGenerating = false;
          this.stopImageEnhancementLoadingMessages();
        });
    } catch (error: any) {
      this.imageEnhancementError =
        error?.message ||
        this.translate.instant("image-enhancement-ai.prepareImageError");
      this.imageEnhancementGenerating = false;
      this.stopImageEnhancementLoadingMessages();
    }
  }

  downloadImageEnhancementImage(image: any) {
    const link = document.createElement("a");
    link.href = image?.dataUrl;
    link.download = image?.fileName || "image-enhancement-ai.jpg";
    link.click();
  }

  addImageEnhancementImageToProperty(image: any) {
    if (!image?.dataUrl) return;

    const id = this.list.images.length + 1;
    const file = this.dataUrlToFile(
      image.dataUrl,
      image.fileName || `image-enhancement-ai-${id}.jpg`,
    );
    const url = URL.createObjectURL(file);
    const safeUrl = this.getSafeImageUrl(url);

    this.list.images.push({
      id,
      name: file.name,
      img: safeUrl,
      caption: '',
      category: "images",
      thumb: safeUrl,
      isNew: true,
      autoCrop: false,
      originalFile: file,
      status: true,
      isAvailable: true,
      hasMaster: true,
      crop: null,
      cropDirty: false,
      cropPreview: null,
      // Regulamento IA da UE (art. 50): marcada automaticamente.
      isAiGenerated: true,
      aiServiceCode: "IMAGE_ENHANCEMENT_AI",
    });

    this.loadImges();
    this.refreshMultimediaWarnings();

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: this.translate.instant("image-enhancement-ai.added"),
      showConfirmButton: false,
      timer: 2200,
    });
  }

  /**
   * Fotos novas: uma de cada vez (descodificar uma foto de 24 MP custa
   * ~100 MB; três em paralelo rebentavam o Safari/iOS), com progresso na
   * página. O browser só reduz a 2000 px e faz a miniatura; o recorte 16:9
   * é do servidor (automático, ou manual pelo cropper).
   */
  async onFileChange(event: any) {
    if (!event.target?.files || event.target.files.length === 0) return;
    const filesArray = Array.from(event.target.files as FileList);
    event.target.value = "";

    const sortedFiles = filesArray.sort((a: File, b: File) =>
      a.name.localeCompare(b.name),
    );
    if (this.countImages + sortedFiles.length > IMAGE_UPLOAD_MAX_COUNT) {
      this.errorMsg(this.translate.instant("t-the-number-of-images-must-be-20"));
      return;
    }

    const tooLarge: string[] = [];
    let added = 0;
    this.setUploadProgress({ current: 0, total: sortedFiles.length, name: "" });

    for (let i = 0; i < sortedFiles.length; i++) {
      const file = sortedFiles[i];
      this.setUploadProgress({ current: i + 1, total: sortedFiles.length, name: file.name });
      try {
        if (!isValidImageType(file)) continue;
        if (file.size > IMAGE_UPLOAD_MAX_ORIGINAL_BYTES) {
          tooLarge.push(file.name);
          continue;
        }

        let dimensions: { width: number; height: number } | null = null;
        try {
          dimensions = await probeImageDimensions(file);
        } catch {
          dimensions = null;
        }
        // Reduzida a 2000 px só quando o original é maior; é o que vai
        // para o servidor e o que o cropper mostra.
        const uploadFile = await prepareUploadFile(file, dimensions);
        if (uploadFile.size > IMAGE_UPLOAD_MAX_BYTES) {
          tooLarge.push(file.name);
          continue;
        }
        const uploadDimensions =
          uploadFile === file
            ? dimensions
            : await probeImageDimensions(uploadFile).catch(() => dimensions);

        // Miniatura de 500 px para o card (derivada da reduzida, barata).
        let thumbFile: File | Blob = uploadFile;
        try {
          thumbFile = await compressImage(uploadFile, IMAGE_THUMB_SIZE);
        } catch (error: any) {
          console.error("Erro ao gerar a miniatura:", error?.message ?? error);
        }
        // Quando o recorte 16:9 perderia demasiado, o servidor publica a
        // imagem inteira com fundo desfocado: o card mostra já o mesmo.
        if (shouldFitWhole(uploadDimensions?.width, uploadDimensions?.height)) {
          thumbFile = await renderFitThumbnail(thumbFile);
        }
        const thumbUrl: any = this.getSafeImageUrl(URL.createObjectURL(thumbFile));
        const fullUrl: any = this.getSafeImageUrl(URL.createObjectURL(uploadFile));

        const id = this.list.images.length + 1;
        this.list.images.push({
          id,
          name: file.name,
          img: thumbUrl,
          caption: "",
          category: "images",
          thumb: thumbUrl,
          isNew: true,
          autoCrop: false,
          originalFile: uploadFile,
          status: true,
          isAvailable: true,
          hasMaster: true,
          masterWidth: uploadDimensions?.width ?? null,
          masterHeight: uploadDimensions?.height ?? null,
          crop: null,
          cropMode: null,
          cropDirty: false,
          cropPreview: null,
        });
        this.images.push({ id, src: fullUrl, caption: "", thumb: thumbUrl });
        this.filterredImages = this.list.images;
        this.countImages = this.list.images.length;
        added++;
        if (added === 1) {
          this.eventService.broadcast("get-data-tab-multimedia");
        }
        this.refreshMultimediaWarnings();
      } catch (error: any) {
        console.error("Erro ao preparar a imagem:", error?.message ?? error);
      }
    }

    this.setUploadProgress(null);
    if (added > 0) this.loadImges();
    if (tooLarge.length > 0) {
      this.errorMsg(
        this.translate.instant("t-upload-files-larger-than-max-mb", {
          max: IMAGE_UPLOAD_MAX_MB,
        }),
      );
    }
  }

  private setUploadProgress(progress: UploadProgress | null) {
    this.uploadProgress = progress;
    // O formulário não deve ser gravado com a lista a meio.
    if (this.propertyMultimediaData) {
      this.propertyMultimediaData.preparingImages = !!progress;
    }
  }

  /** Recorte disponível: imagem nova com ficheiro, ou guardada (master ou publicada). */
  canCrop(data: any): boolean {
    if (!data) return false;
    if (data.isNew) return !!data.originalFile;
    return data.isAvailable !== false;
  }

  /** Imagem anterior ao recorte real: recorta-se dentro da publicada. */
  isLegacyCrop(data: any): boolean {
    return !!data && !data?.isNew && !data?.hasMaster;
  }


  formatType(type: any) {
    return type.split("/")[1];
  }

  cropImage(img: any) {
    this.showCropper = true;
    this.cropperComponent.open(img);
  }

  deleteImage(data: any) {
    this.list.images = this.list.images.filter(
      (x: { id: any }) => x.id !== data.id,
    );
    for (let i = 0; i < this.list.images.length; i++) {
      this.list.images[i].id = i + 1;
    }

    this.loadImges();

    if (!data.isNew) this.listDeleteImages.push(data);
    this.eventService.broadcast("get-data-tab-multimedia");

    this.refreshMultimediaWarnings();
  }

  deleteVideo(data: any) {
    this.list.videos = this.list.videos.filter(
      (x: { id: any }) => x.id !== data.id,
    );

    this.loadVideos();

    if (!data.isNew) this.listDeleteVideos.push(data);
    this.eventService.broadcast("get-data-tab-multimedia");

    this.refreshMultimediaWarnings();
  }

  /**
   * Title sweet alert
   * @param Error Msg modal content
   */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: this.translate.instant("t-something-wrong"),
      text: errorMsg,
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: "Close",
    });
  }

  onchangeCaption(event: Event, data: any) {
    // const newValue = (event.target as HTMLInputElement).value;
    // data.caption = newValue;
    data.caption = event;
    let dimage: any = this.images.find((x: { id: any }) => x.id === data.id);
    if (dimage) {
      dimage.caption = data.caption;
    }
  }

  onChangeActive(event: Event, data: any) {
    data.status = event;

    this.eventService.broadcast("get-data-tab-multimedia");
  }

  /**
   * Switch manual "gerada/alterada por IA" (Regulamento IA da UE, art. 50).
   * Ligar sem serviço conhecido regista MANUAL; desligar limpa o serviço.
   */
  onChangeAiGenerated(value: boolean, data: any) {
    data.isAiGenerated = !!value;
    data.aiServiceCode = value ? data.aiServiceCode || "MANUAL" : null;

    this.eventService.broadcast("get-data-tab-multimedia");
  }

  onchangeImageOrder(event: any, data1: any) {
    const idData1 = data1.id;
    const idData2 = +event.target.value;
    if (idData1 !== idData2) {
      let d1: any = this.list.images.find((x: { id: any }) => x.id === idData1);
      let d2: any = this.list.images.find(
        (x: { id: number }) => x.id === idData2,
      );
      if (d1 && d2) {
        d1.id = idData2;
        d2.id = idData1;
      }
    }
    this.orderImages();
  }

  orderImages() {
    setTimeout(() => {
      this.list.images.sort((a: any, b: any) => {
        return a.id - b.id;
      });
      this.loadImges();
    });
  }

  /**
   * Open subscribe modal
   * @param subscribeDataModal subscribe modal data
   */
  subscribeModal(subscribeDataModal: any) {
    this.modalAddVideo = this.modalService.open(subscribeDataModal, {
      size: "lg",
      centered: true,
      backdropClass: "custom-body",
    });
  }

  private onReceivedEvent(event: IEvent): void {
    if (event.id === LIGHTBOX_EVENT.OPEN) {
    }
    if (event.id === LIGHTBOX_EVENT.CLOSE) {
      this.lightboxsubscription.unsubscribe();
    }
  }

  saveVideo(value: any) {
    if (`${value}`.trim().length > 0) {
      const id = this.list.videos.length + 1;
      let link: any = this.getTrustedVideoURL(value);
      this.list.videos.push({
        id: id,
        link: link,
        category: "videos",
        isNew: true,
        status: true,
        videoId: 0,
      });
      this.loadVideos();
      this.modalAddVideo.dismiss();

      this.propertyMultimediaData.errors = this.buildMultimediaErrors();
      this.eventService.broadcast("check-warning-add-property");
    }
  }

  getTrustedVideoURL(videoURL: string): SafeResourceUrl {
    let srclink = videoURL;

    if (srclink.startsWith("https://www.youtube.com/watch?v=")) {
      let embedlink = srclink.replace("watch?v=", "embed/");
      embedlink = embedlink.split("&")[0];
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedlink);
    } else if (srclink.startsWith("https://youtu.be")) {
      let embedlink = srclink.replace(
        "https://youtu.be",
        "https://www.youtube.com/embed/",
      );
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedlink);
    } else if (
      srclink.startsWith("https://www.youtube.com/shorts/") ||
      srclink.startsWith("https://youtube.com/shorts/")
    ) {
      // Transformar Shorts em embed
      let embedlink = srclink.replace("/shorts/", "/embed/");
      return this.sanitizer.bypassSecurityTrustResourceUrl(embedlink);
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(srclink);
    }
  }

  onImageError(event: any, data: any) {
    event.target.src = "assets/images/no-image-available1_1.jpeg";
    if (data?.status) {
      data.isAvailable = false;
      const img = this.images.find((im) => im.id === data.id);
      if (img) {
        img.src = "assets/images/no-image-available1_1.jpeg";
        img.thumb = "assets/images/no-image-available1_1.jpeg";
      }
    }
  }

  blockScroll() {
    if (this.simplebarMultimedia) {
      // Acessa o elemento de rolagem do Simplebar e bloqueia o scroll
      const scrollElement =
        this.simplebarMultimedia.SimpleBar.getScrollElement();
      if (scrollElement) {
        // Bloqueia rolagem definindo pointer-events como 'none'
        scrollElement.style.pointerEvents = "none";
        scrollElement.scrollTop = scrollElement.scrollTop; // Manter a posição atual do scroll
      }
    }
  }

  unlockScroll() {
    if (this.simplebarMultimedia) {
      // Acessa o elemento de rolagem do Simplebar e desbloqueia o scroll
      const scrollElement =
        this.simplebarMultimedia.SimpleBar.getScrollElement();
      if (scrollElement) {
        // Restaura pointer-events para 'auto' para permitir rolagem
        scrollElement.style.pointerEvents = "auto";
      }
    }
  }

  dataUrlToFile(dataUrl: string, filename: string): File {
    const split = dataUrl.split(",");
    const mime = split[0].match(/:(.*?);/)?.[1] || "image/jpeg";
    const byteString = atob(split[1]);
    let ab = byteString.length;
    const ia = new Uint8Array(ab);
    while (ab--) {
      ia[ab] = byteString.charCodeAt(ab);
    }
    return new File([ia], filename, { type: mime });
  }

  getSafeImageUrl(url: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  /** Partilha as imagens novas (ainda não guardadas) para a geração de descrição com IA */
  private syncListingImages() {
    const pendingFiles = (this.list?.images ?? [])
      .filter(
        (img: any) =>
          img?.isNew &&
          img?.status !== false &&
          (img?.originalFile instanceof File ||
            img?.originalFile instanceof Blob),
      )
      .slice(0, 6)
      .map((img: any, index: number) => {
        const source = img.originalFile;
        if (source instanceof File) return source;
        return new File([source], img?.name || `imagem-${index + 1}.jpg`, {
          type: source?.type || "image/jpeg",
        });
      });

    this.propertyDataService.updateListingImages(pendingFiles);
  }

  refreshMultimediaWarnings() {
    this.list.first = this.multimediaFirst;

    this.syncListingImages();

    this.propertyMultimediaData.data = this.list;
    this.propertyMultimediaData.dataDeleteImages = this.listDeleteImages;
    this.propertyMultimediaData.dataDeleteVideos = this.listDeleteVideos;

    this.propertyMultimediaData.errors = this.buildMultimediaErrors();

    this.multimediaMinError = this.propertyMultimediaData.errors?.find(
      (error: any) =>
        error.key === "multimedia.mediaMin" && error.type?.warning,
    );

    this.showMultimediaMinWarning = !!this.multimediaMinError;

    this.eventService.broadcast("check-warning-add-property");
  }

  private isRuleEnabled(): boolean {
    return this.propertyValidationService.isEnabled("multimedia.mediaMin");
  }

  private countActiveMedia(): number {
    const images = (this.list?.images ?? []).filter((img: any) => {
      const active = img?.status === undefined ? true : img?.status === true;

      return active;
    }).length;

    const videos = (this.list?.videos ?? []).filter((video: any) => {
      const active =
        video?.status === undefined ? true : video?.status === true;

      return active;
    }).length;

    return images + videos;
  }

  private buildMultimediaErrors(): any[] {
    if (!this.isRuleEnabled()) return [];

    const min = this.propertyValidationService.minValue("multimedia.mediaMin");
    const activeCount = this.countActiveMedia();

    return activeCount >= min
      ? []
      : [
        {
          key: "multimedia.mediaMin",
          type: { warning: true },
          valueMin: min,
          activeCount,
        },
      ];
  }

  async downloadImage(image: any, index?: number) {
    try {
      const file = await this.resolveHomeStagingSourceFile(image);

      const fileName = this.getDownloadImageName(image, file);

      const url = URL.createObjectURL(file);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(url);
      // Pedido entregue ao browser; a gravação em disco não é confirmável.
      this.trackImageEvent(image, "PROPERTY_IMAGE_DOWNLOAD_REQUESTED");
    } catch (error) {
      console.error("Erro ao baixar imagem:", error);

      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível baixar a imagem.",
      });
    }
  }


  async downloadAllImages() {
    if (!this.filterredImages?.length) {
      return;
    }

    try {
      this.loadingService.setLoading(true);

      const zip = new JSZip();

      for (let i = 0; i < this.filterredImages.length; i++) {
        const image = this.filterredImages[i];

        try {
          const file = await this.resolveHomeStagingSourceFile(image);
          const fileName = this.getDownloadImageName(image, file);

          zip.file(fileName, file);
        } catch (error) {
          console.error(
            `Erro ao adicionar imagem ${i + 1} ao ZIP:`,
            error
          );
        }
      }

      const zipBlob = await zip.generateAsync({
        type: "blob",
      });

      const url = URL.createObjectURL(zipBlob);

      const link = document.createElement("a");
      link.href = url;

      link.download = this.property?.id
        ? `imovel-${this.property.id}-imagens.zip`
        : "imagens-imovel.zip";

      document.body.appendChild(link);
      link.click();
      link.remove();

      URL.revokeObjectURL(url);
      this.filterredImages.forEach((image: any) =>
        this.trackImageEvent(image, "PROPERTY_IMAGE_DOWNLOAD_REQUESTED"),
      );

    } catch (error) {
      console.error("Erro ao baixar imagens:", error);

      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Não foi possível baixar todas as imagens.",
      });
    } finally {
      this.loadingService.setLoading(false);
    }
  }


  private getDownloadImageName(
    image: any,
    file: File | Blob
  ): string {

    let fileName = "";

    if (image?.name) {
      fileName = String(image.name);
    } else if (file instanceof File && file.name) {
      fileName = file.name;
    } else {
      const extension = this.getImageExtension(file.type);
      return `imagem.${extension}`;
    }

    // Corrige nomes como:
    // foto.jpg1  -> foto.jpg
    // foto.jpg2  -> foto.jpg
    // foto.jpeg3 -> foto.jpeg
    // foto.png4  -> foto.png
    // foto.webp5 -> foto.webp
    fileName = fileName.replace(
      /\.(jpg|jpeg|png|webp)\d+$/i,
      ".$1"
    );

    return fileName;
  }
  private getImageExtension(mimeType?: string): string {
    switch (mimeType) {
      case "image/png":
        return "png";

      case "image/webp":
        return "webp";

      case "image/jpeg":
      case "image/jpg":
      default:
        return "jpg";
    }
  }

  onImageDragStart(event: DragEvent, index: number): void {

    if (!this.canEditMultimedia()) {
      event.preventDefault();
      return;
    }

    this.draggedImageIndex = index;

    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", String(index));
    }
  }


  onImageDragOver(event: DragEvent, targetIndex: number): void {

    if (this.draggedImageIndex === null) {
      return;
    }

    event.preventDefault();

    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = "move";
    }

    // Não mostra indicador sobre a própria imagem
    if (targetIndex === this.draggedImageIndex) {
      this.dragOverImageIndex = null;
      this.dragOverPosition = null;
      return;
    }

    const element = event.currentTarget as HTMLElement;
    const rect = element.getBoundingClientRect();

    /*
     * Se o rato estiver na primeira metade da imagem:
     * inserir ANTES.
     *
     * Se estiver na segunda metade:
     * inserir DEPOIS.
     */
    const middle = rect.left + rect.width / 2;

    this.dragOverImageIndex = targetIndex;

    this.dragOverPosition =
      event.clientX < middle
        ? "before"
        : "after";
  }


  onImageDrop(event: DragEvent, targetIndex: number): void {

    event.preventDefault();
    event.stopPropagation();

    const sourceIndex = this.draggedImageIndex;

    if (sourceIndex === null) {
      this.resetImageDrag();
      return;
    }

    if (sourceIndex === targetIndex) {
      this.resetImageDrag();
      return;
    }

    const reorderedImages = [...this.filterredImages];

    /*
     * Determina em que posição queremos colocar
     * a imagem.
     */
    let insertionIndex =
      targetIndex +
      (this.dragOverPosition === "after" ? 1 : 0);

    /*
     * Remove a imagem da posição original.
     */
    const [movedImage] = reorderedImages.splice(
      sourceIndex,
      1
    );

    /*
     * Como removemos um elemento, os índices que
     * estavam à direita diminuem 1.
     */
    if (sourceIndex < insertionIndex) {
      insertionIndex--;
    }

    /*
     * Garante que o índice continua válido.
     */
    insertionIndex = Math.max(
      0,
      Math.min(insertionIndex, reorderedImages.length)
    );

    /*
     * INSERE a imagem.
     *
     * Não existe troca entre duas imagens.
     * As restantes deslocam-se automaticamente.
     */
    reorderedImages.splice(
      insertionIndex,
      0,
      movedImage
    );

    /*
     * Atualiza a ordem.
     */
    reorderedImages.forEach(
      (image: any, index: number) => {
        image.id = index + 1;
      }
    );

    /*
     * Atualiza a lista principal.
     */
    this.list.images = reorderedImages;

    /*
     * Atualiza galeria/lightbox.
     */
    this.loadImges();

    /*
     * Atualiza os dados enviados para o formulário.
     */
    this.refreshMultimediaWarnings();

    this.eventService.broadcast(
      "get-data-tab-multimedia"
    );

    this.resetImageDrag();
  }


  onImageDragEnd(): void {
    this.resetImageDrag();
  }


  private resetImageDrag(): void {
    this.draggedImageIndex = null;
    this.dragOverImageIndex = null;
    this.dragOverPosition = null;
  }

  ngOnDestroy(): void {
    this.eventService.broadcast("get-data-tab-multimedia");
    this.stopHomeStagingLoadingMessages();
    this.stopImageEnhancementLoadingMessages();
    this.subscriptionCropImage.unsubscribe();
    this.subscriptionSubmitted.unsubscribe();
    this.subscriptionRules?.unsubscribe();
  }
}
